document.addEventListener('DOMContentLoaded', function() {
  const toggleButtons = document.querySelectorAll('.toggle-view');
  const gridContainer = document.querySelector('.collection-grid__wrapper .grid.grid--uniform');
  const wrapper = document.querySelector('.collection-grid__wrapper');
  const pageType = wrapper ? wrapper.dataset.pageType : null;

  const mq = window.matchMedia("(min-width: 768px)");

  function initViewToggle() {
    if (!gridContainer) return;

    // Check if already has mode-grid or mode-list
    let currentMode = [...gridContainer.classList].find(c => c.startsWith("mode-"));

    // If no mode set yet, assign default
    if (!currentMode) {
      let defaultView = pageType === "search" ? "grid" : "list";
      gridContainer.classList.add(`mode-${defaultView}`);
      currentMode = `mode-${defaultView}`;
    }

    // Update toggle UI
    const activeView = currentMode.replace("mode-", "");
    toggleButtons.forEach(btn => {
      btn.classList.toggle("active-toggle", btn.dataset.view === activeView);
    });

    // Add click events
    toggleButtons.forEach(button => {
      button.addEventListener('click', function() {
        const view = this.dataset.view;

        gridContainer.classList.remove('mode-grid', 'mode-list');
        gridContainer.classList.add(`mode-${view}`);

        toggleButtons.forEach(btn => btn.classList.remove('active-toggle'));
        this.classList.add('active-toggle');
      });
    });
  }

  initViewToggle();
  mq.addEventListener("change", initViewToggle);
});

function scrollToGroup(id) {
  var target = document.querySelector('#group-div-' + id);
  if (!target) return;

  var header = document.querySelector('.site-header');
  var headerOffset = (header ? header.offsetHeight : 0) + 20;
  var elementPosition = target.getBoundingClientRect().top + window.scrollY;
  window.scrollTo({
    top: elementPosition - headerOffset,
    behavior: 'smooth'
  });
}

